export default "__VITE_ASSET__48a05b79__"